/** Build otpauth URI for authenticator apps (Google / Microsoft Authenticator, etc.). */
export function buildOtpAuthUri({ secret, accountEmail, issuer = 'GillyReach' }) {
  const normalized = String(secret || '')
    .replace(/\s+/g, '')
    .toUpperCase();
  if (!normalized) return null;
  const email = String(accountEmail || 'mailbox').trim() || 'mailbox';
  const iss = String(issuer || 'GillyReach').trim();
  const label = encodeURIComponent(`${iss}:${email}`);
  const secretParam = encodeURIComponent(normalized);
  const issuerParam = encodeURIComponent(iss);
  return `otpauth://totp/${label}?secret=${secretParam}&issuer=${issuerParam}`;
}
